import {
  FETCH_BASKET_REQUEST,
  FETCH_BASKET_SUCCESS,
  FETCH_BASKET_ERROR,
  UPDATE_BASKET_REQUEST,
  UPDATE_BASKET_SUCCESS,
  UPDATE_BASKET_ERROR,
  CLEAR_BASKET_REQUEST,
  CLEAR_BASKET_SUCCESS,
  CLEAR_BASKET_ERROR,
  CLEAR_PRODUCT_WARNING_MESSAGE,
} from '../actions/basket';

import basketModes from 'apps/basket/utils/basketModes';
import { fetchBasketError, fetchBasketRequest, fetchBasketSuccess } from './basketFetchActions';
import { updateBasketError, updateBasketRequest, updateBasketSuccess } from './basketUpdateActions';
import {
  clearBasketError,
  clearBasketRequest,
  clearBasketSuccess,
  clearProductWarningMessage,
} from './basketClearActions';

export const initialState = {
  items: [],
  minimumOrderValue: 40,
  mode: basketModes.PLACE_NEW,
  transactionId: undefined,
  numberOfItems: 0,
  offerSavings: 0,
  productWarnings: {},
  productWarningsMessages: {},
  promotionsExceedingLimit: [],
  value: 0,
};

const ACTIONS = {
  [FETCH_BASKET_REQUEST]: fetchBasketRequest,
  [FETCH_BASKET_SUCCESS]: fetchBasketSuccess,
  [FETCH_BASKET_ERROR]: fetchBasketError,
  [UPDATE_BASKET_REQUEST]: updateBasketRequest,
  [UPDATE_BASKET_SUCCESS]: updateBasketSuccess,
  [UPDATE_BASKET_ERROR]: updateBasketError,
  [CLEAR_BASKET_REQUEST]: clearBasketRequest,
  [CLEAR_BASKET_SUCCESS]: clearBasketSuccess,
  [CLEAR_BASKET_ERROR]: clearBasketError,
  [CLEAR_PRODUCT_WARNING_MESSAGE]: clearProductWarningMessage,
};

export default (state = initialState, action) => (ACTIONS[action.type] ? ACTIONS[action.type](state, action) : state);
